<template>
  <template v-for="(item, index) in props.items" :key="item?.key ?? index">
    <!-- 分隔线 -->
    <a-menu-divider v-if="item.type === 'divider'" />

    <!-- 普通菜单项 -->
    <a-menu-item
      v-else-if="!item.subMenu || item.subMenu.length === 0"
      v-bind="getMenuItemProps(item)"
      @click="handleClick(item)"
    >
      <template v-if="item.icon" #icon>
        <ll-icon
          :icon-name="item.icon"
          :color="item.disabled ? '' : item.color"
        />
      </template>
      <span :style="{ color: item.disabled ? '' : item.color }">
        {{ item.label }}
      </span>
    </a-menu-item>

    <!-- 子菜单 -->
    <a-sub-menu v-else v-bind="getSubMenuProps(item)">
      <template v-if="item.icon" #icon>
        <ll-icon
          :icon-name="item.icon"
          :color="item.disabled ? '' : item.color"
        />
      </template>
      <template #title>
        <span :style="{ color: item.disabled ? '' : item.color }">
          {{ item.label }}
        </span>
      </template>
      <RecursiveMenu :items="item.subMenu" @claim-selected="handleClick" />
    </a-sub-menu>
  </template>
</template>

<script setup lang="ts">
import type { DropdownItem } from './dropdown'

defineOptions({ name: 'RecursiveMenu' })

const props = defineProps({
  items: {
    type: Array as () => DropdownItem[],
    default: () => [],
  },
})

const emit = defineEmits({
  claimSelected: (item: DropdownItem) => !!item,
})

// 提取菜单项属性（排除不需要的属性）
const getMenuItemProps = (item: DropdownItem) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { label, subMenu, type, icon, color, ...rest } = item
  return rest
}

// 提取子菜单属性
const getSubMenuProps = (item: DropdownItem) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { label, subMenu, icon, color, ...rest } = item
  return rest
}

const handleClick = (item: DropdownItem) => {
  emit('claimSelected', item)
}
</script>
